var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-card',[_c('BackofficeBaseList',{attrs:{"items":_vm.items,"headers":_vm.headers,"actions":_vm.actionsItems,"title":_vm.$t('title'),"item-key":"docId"},on:{"reloadDataClick":_vm.reload,"task:unlock":_vm.onTaskUnlock}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }